export default __webpack_public_path__ + "static/media/mighty-for-you-mobile.66c00f9a.svg";